import {
	Box,
	styled,
} from '@mui/material'

const SIZE_MAP = {
	small:  24,
	medium: 40,
	large:  60,
}

export const LoaderRoot = styled(Box)<{
	size: 'medium' | 'small' | 'large'
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: ${({
		size,
	}): number => {
		return SIZE_MAP[size] * 0.2
	}}px;
`

export const LoaderDot = styled(Box)<{
	size: 'medium' | 'small' | 'large'
}>` 
	width: ${({
		size,
	}): number => {
		return SIZE_MAP[size] * 0.25
	}}px; 
	height: ${({
		size,
	}): number => {
		return SIZE_MAP[size] * 0.25
	}}px;
	border-radius: 50%;
	background: linear-gradient(135deg, var(--error-color) 0%, var(--don-color) 100%);
`
